/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Fix_Error_AriaInputs */



/**
* | output |
* | --- |
* | "Fix this error" |
*
* @param {Qc_Fix_Error_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_fix_error_aria = /** @type {((inputs?: Qc_Fix_Error_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Fix_Error_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Corriger cette erreur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesen Fehler korrigieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Correggi questo errore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Исправить эту ошибку")
	if (locale === "es") return /** @type {LocalizedString} */ ("Corregir este error")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("修复此错误")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このエラーを修正")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह त्रुटि ठीक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Corrigir este erro")
	return /** @type {LocalizedString} */ ("Fix this error")
});